export const FileTypes = Object.freeze({
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  DOC: 'application/msword',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  PDF: 'application/pdf'
});
